import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from '@/services';
import type { RouteDefinition } from '@/types';
import { notifyLiveDataError } from '@/utils';

/** Subscribes to every route in the catalog (active and inactive), for admin management. */
export const useAllRoutes = () => {
  const [routes, setRoutes] = useState<RouteDefinition[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'routes'), orderBy('name', 'asc'));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        setRoutes(
          snapshot.docs.map((docSnap) => {
            const route = docSnap.data() as RouteDefinition;
            return {
              ...route,
              id: docSnap.id,
              category: route.category ?? 'pakkeshop',
              extraDurationHours: route.extraDurationHours ?? null,
            };
          }),
        );
        setLoading(false);
      },
      (error) => {
        notifyLiveDataError('useAllRoutes', error);
        setLoading(false);
      },
    );
    return unsubscribe;
  }, []);

  return { routes, loading };
};
